((angular) => {
  "use strict";

  angular.module("App", [
    "Common",
    "Auth",
    "Pages"
  ]);

})(angular);
